/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode, useCallback, useEffect, useMemo, useState } from 'react'
import { Modal } from 'shared'
import ModalDonateCoinStyled from './styled'
import { notification } from 'antd'
import Button from 'shared/Button'
import {
  CLOSE_BTN,
  GAME_TOKEN_KUDA,
  GAME_TOKEN_MERAH,
  ICON_ADIL,
  ICON_ADIL_CHAIN,
  ICON_META_HORSE,
  LINE_GUILD_GRADIENT,
  TWO_LINE
} from 'assets/images'
import { useTranslation } from 'react-i18next'
import { GUILD_MESSAGE, LENDING_MESSAGE, NOTIFICATION_MESSAGE } from 'i18n/constants'
import { CURRENCY_TYPE, NUMBER, STATUS_TRANSACTION, timeCheckNonce } from 'apps/constants'
import { useAvailableWallet } from 'features/Auth/pages/Main/useAvailableWallet'
import { ethers } from 'ethers'
import {
  checkAnyWalletEnabled,
  convertGasPrice,
  getGasPriceOption,
  getImgByKey,
  getOnlyDecimal,
  handleAsyncRequest,
  removeDataAtLocalStorage
} from 'utils/helper'
import { getCurrentUser } from 'utils/metamask'
import userApi from 'apis/userApi'
import guildApi from 'apis/guildApi'
import { useAppDispatch, useAppSelector, useReloadCurrentPage, useToggle } from 'hooks'
import { setCurrentUser } from 'features/Profile/profile.slice'
import { setCoinUser } from 'features/Balance/coinUser.slice'
import { links, paths } from 'apps'
import { Coin, CoinUser, GetRaceListParams } from 'models'
import InputPrizePool from 'shared/InputPrizePool'
import SelectCustomCreateRace from 'shared/SelectCustomCreateRace'
import { configs } from 'apps'
import guildVaultABI from 'json/GuildVault.json'
import { BigNumber } from 'ethers'
import InProgressBalanceModal from 'features/Balance/components/InProgress'
import { getCoinList } from 'apps/redux/userCreateRace/action'
import { useNavigate } from 'react-router-dom'
import ModalConfirm from 'features/Guild/components/ModalConfirmEditGuild'

interface ModalProps {
  toggleIsModalOpen: (value?: boolean) => void
  onCloseButtonClick: () => void
  onConfirmDonate: () => void
}

interface ItemTypeFilters {
  name: string
  isActive: boolean
  icon: ReactNode
}

interface ResultDonate {
  adil_amount: number
  block_expired: number
  gas_price: number
  guild_id: number
  item_ids: number[]
  nonce: string
  ticket_amounts: number[]
  ticket_ids: number[]
  r: string
  s: string
  v: number
}

interface RequestDonate {
  guildId: string
  blockExpired: string
  itemIds: string[] | null
  ticketIds: string[] | null
  ticketAmounts: string[] | null
  adilAmount: BigNumber
  nonce: string | null
  r: string
  s: string
  v: number
}

const contract = {
  tokenGuildVault: configs.guildVault
}

const currencyOptions: ItemTypeFilters[] = [
  {
    name: CURRENCY_TYPE.MERAH,
    isActive: false,
    icon: <img className='mr-2' alt='Merah' src={getImgByKey(CURRENCY_TYPE.MERAH_NEW)} width={25} />
  },
  {
    name: CURRENCY_TYPE.KUDA,
    isActive: false,
    icon: <img className='mr-2' alt='Merah' src={getImgByKey(CURRENCY_TYPE.KUDA_NEW)} width={25} />
  },
  {
    name: CURRENCY_TYPE.ADIL,
    isActive: false,
    icon: <img className='mr-2' alt='Merah' src={getImgByKey(CURRENCY_TYPE.ADIL)} width={25} />
  }
]

const defaultParams: GetRaceListParams = {
  limit: NUMBER.TWENTY,
  page: NUMBER.ONE
}

export default function DonateCoin({ onCloseButtonClick, onConfirmDonate }: ModalProps) {
  const [, contextHolder] = notification.useNotification()
  const navigate = useNavigate()
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const { t } = useTranslation()
  const [coinADIL, setCoinADIL] = useState<number>(0)
  const [coinKuda, setCoinKuda] = useState<number>(0)
  const [coinMerah, setCoinMerah] = useState<number>(0)
  const [inputUser, setInputUser] = useState<number>(0)
  const [currencySelected, setCurrencySelected] = useState<string>(CURRENCY_TYPE.MERAH)
  const dispatch = useAppDispatch()
  const { coinUser, profile } = useAppSelector(state => state)
  const [openInProgressBalanceModal, toggleOpenInProgressBalanceModal] = useToggle(false)
  const [isConfirm, setIsConfirm] = useState(false)
  const providers = useAvailableWallet()
  const storedWalletName = localStorage.getItem('walletName')

  const matchedProviderDetail = providers.find(p => p.info.name === storedWalletName)
  const ethereumProvider = matchedProviderDetail?.provider ?? window.ethereum
  const provider = new ethers.providers.Web3Provider(ethereumProvider)
  const signer = provider.getSigner()

  const getCoinADIL = async () => {
    const addressUser = await signer.getAddress()
    const balance = await provider.getBalance(addressUser)
    const data = +ethers.utils.formatEther(balance)
    setCoinADIL(+data?.toFixed(5) || 0)
  }

  const fetchCoinUser = useCallback(async () => {
    const [error, resultCoinUser]: any = await handleAsyncRequest(userApi.getUserItems())
    if (error?.code === 403) {
      window.location.href = paths.auth.login()
    }
    if (!resultCoinUser) return
    const handleCoinUser = (data: CoinUser) => {
      data.items.filter((item: Coin) => {
        if (item.item_type === CURRENCY_TYPE.KUDA) {
          setCoinKuda(item.amount)
        }

        if (item.item_type === CURRENCY_TYPE.MERAH) {
          setCoinMerah(item.amount)
        }
      })
    }

    handleCoinUser(resultCoinUser.data)
  }, [])

  useEffect(() => {
    if (providers?.length) {
      const checkCurrentCoinUser = async () => {
        const [, currentUser]: any = await handleAsyncRequest(getCurrentUser())
        if (!currentUser) return

        const [, resultCoinUser] = await handleAsyncRequest(userApi.getUserItems())
        if (!resultCoinUser) return

        dispatch(setCurrentUser(currentUser))
        dispatch(setCoinUser(resultCoinUser.data))
      }

      checkCurrentCoinUser()
      fetchCoinUser()
      getCoinADIL()
    }
  }, [providers])

  useEffect(() => {
    if (coinUser) {
      coinUser?.items?.map((item: any) => {
        if (item.item_type === 'MERAH_NEW') {
          setCoinMerah(() => item?.amount || 0)
        } else if (item.item_type === 'KUDA_NEW') {
          setCoinKuda(() => item?.amount || 0)
        }
      })
    }
  }, [coinUser])

  const layoutCoin = (logo: string, name: string, price: string | number) => {
    return (
      <div className='wallet-item'>
        <div>
          <img src={logo} alt='' className='icon-coin' />
        </div>
        <div className='name-coin'>{name}</div>
        <div className='value-coin'>{price}</div>
      </div>
    )
  }

  const _handleKeyDownPrize = (e: any) => {
    if (['e', 'E', '+', '-', ','].includes(e.key) || [38, 40].includes(e.keyCode)) {
      return e.preventDefault()
    }

    if (e.key === 'Unidentified') {
      return
    }
  }

  const transactionFaild = (value: any) => {
    toggleOpenInProgressBalanceModal(false)
    notification.error({
      message: 'ERROR',
      description: value ?? 'Sorry! Your transaction has failed. Please go back and try again.',
      placement: 'bottomRight',
      duration: 4,
      className: 'ant-custom-error',
      icon: <></>
    })
  }

  const transactionSuccess = () => {
    toggleOpenInProgressBalanceModal(false)
    notification.success({
      message: 'SUCCESS',
      description: `Donate successfully!`,
      placement: 'bottomRight',
      duration: 4,
      className: 'ant-custom-success'
    })
    dispatch(getCoinList({ guildId: profile?.guild_id, params: defaultParams }))
  }

  const checkNonceContract = async (nonce: string) => {
    let checkNonceExits = null as any
    let x = 0
    const intervalID = setInterval(async () => {
      const [, result] = await handleAsyncRequest(guildApi.postCheckNonceGuildAdil({ nonce }))
      if (!result) return
      checkNonceExits = result.data.status
      if (checkNonceExits === STATUS_TRANSACTION.success) {
        clearInterval(intervalID)
        transactionSuccess()
        fetchCoinUser()
        onConfirmDonate()
      }

      if (checkNonceExits === STATUS_TRANSACTION.expired) {
        clearInterval(intervalID)
        toggleOpenInProgressBalanceModal(false)
        transactionFaild(t(`${LENDING_MESSAGE}.failedTransaction`))
      }

      if (++x === 10) {
        if (checkNonceExits === STATUS_TRANSACTION.pending) {
          clearInterval(intervalID)
          toggleOpenInProgressBalanceModal(false)
          transactionFaild(t(`${NOTIFICATION_MESSAGE}.transferredPending`))
        }
      }
    }, timeCheckNonce)
  }

  const transactionContract = async (value: ResultDonate) => {
    if (!value) return
    try {
      const ethContract = new ethers.Contract(contract.tokenGuildVault, guildVaultABI.contract.abi, signer)
      try {
        const request: RequestDonate = {
          guildId: value.guild_id.toString(),
          itemIds: [],
          ticketIds: [],
          ticketAmounts: [],
          adilAmount: ethers.utils.parseEther(value.adil_amount.toString()),
          blockExpired: value.block_expired.toString(),
          nonce: value.nonce,
          v: value.v,
          r: value.r,
          s: value.s
        }
        const tx = await ethContract.deposit(request, getGasPriceOption(convertGasPrice(value.gas_price), {
          value: ethers.utils.parseEther(value.adil_amount.toString())
        }))
        if (tx.hash) {
          setLoadingSubmit(false)
          checkNonceContract(value.nonce)
        }
      } catch (err: any) {
        setLoadingSubmit(false)
        transactionFaild(err?.error?.data?.message)
        toggleOpenInProgressBalanceModal(false)
      }
    } catch (err: any) {
      setLoadingSubmit(false)
      transactionFaild(err?.error?.data?.message)
      toggleOpenInProgressBalanceModal(false)
    }
  }

  const handleConfirmSubmit = async () => {
    setLoadingSubmit(true)
    const payload = {
      coin: {
        amount: Number(inputUser),
        coin_type: currencySelected === CURRENCY_TYPE.ADIL ? currencySelected : `${currencySelected}_NEW`
      },
      guild_id: Number(profile?.guild_id)
    }
    if (currencySelected === CURRENCY_TYPE.ADIL) {
      const isWalletEnabled = await checkAnyWalletEnabled(storedWalletName as string)
      if (!isWalletEnabled) {
        setLoadingSubmit(false)
        removeDataAtLocalStorage()
        navigate(links.home.index())
        useReloadCurrentPage()
        return
      }
    }
    const [error, result]: any = await handleAsyncRequest(guildApi.postDonateCoin(payload))
    if (error) {
      setLoadingSubmit(false)
      notification.error({
        message: 'ERROR',
        description: error?.message || 'Can not donate COIN',
        placement: 'bottomRight',
        duration: 4,
        className: 'ant-custom-error',
        icon: <></>
      })
      return
    }
    if (result) {
      if (currencySelected === CURRENCY_TYPE.ADIL) {
        toggleOpenInProgressBalanceModal(true)
        await transactionContract(result.data)
      } else {
        transactionSuccess()
        fetchCoinUser()
        onConfirmDonate()
      }
    }
  }

  const handleChangeCoinInput = (val: any) => {
    if (currencySelected === CURRENCY_TYPE.MERAH) {
      if (Number(val) > coinMerah) {
        setInputUser(getOnlyDecimal(String(coinMerah), NUMBER.NUM_2147483647))
      } else {
        setInputUser(getOnlyDecimal(val, NUMBER.NUM_2147483647))
      }
    }
    if (currencySelected === CURRENCY_TYPE.KUDA) {
      if (Number(val) > coinKuda) {
        setInputUser(getOnlyDecimal(String(coinKuda), NUMBER.NUM_2147483647))
      } else {
        setInputUser(getOnlyDecimal(val, NUMBER.NUM_2147483647))
      }
    }
    if (currencySelected === CURRENCY_TYPE.ADIL) {
      if (Number(val) > coinADIL) {
        setInputUser(getOnlyDecimal(String(coinADIL), NUMBER.NUM_2147483647))
      } else {
        setInputUser(getOnlyDecimal(val, NUMBER.NUM_2147483647))
      }
    }
  }

  const handleSave = () => {
    setIsConfirm(true)
  }

  const isShowWarning = useMemo(() => {
    if (currencySelected === CURRENCY_TYPE.ADIL) {
      return Number(inputUser) === coinADIL
    }
  }, [currencySelected, coinADIL, inputUser])

  return (
    <Modal>
      <ModalDonateCoinStyled>
        {contextHolder}
        <div className='donate-coin-modal'>
          <button className='close-btn p-0 position-absolute' role='button' onClick={onCloseButtonClick}>
            <img src={CLOSE_BTN} alt='close' />
          </button>
          <div className='title-modal'>
            <div className={`color-primary`}>{t(`${GUILD_MESSAGE}.donateToGuildVault`)}</div>
            <img src={TWO_LINE} alt='' />
          </div>
          <div className='content-modal'>
            <div className='row line__guild--gradiant'>
              <img src={LINE_GUILD_GRADIENT} />
            </div>
            <div className='container'>
              <div className='balance-container'>
                <div className='balance'>
                  <div className='title font-bold'>{t(`${NOTIFICATION_MESSAGE}.balance`)}</div>
                  <img src={TWO_LINE} alt='' className='line' />
                </div>

                <div className='wallet'>
                  <div>
                    <div className='wallet-title'>
                      <img src={ICON_ADIL_CHAIN} alt='' className='wallet-icon' width={25} />
                      {t(`${NOTIFICATION_MESSAGE}.adilChainCoin`)}
                    </div>
                    {layoutCoin(ICON_ADIL, CURRENCY_TYPE.ADIL, coinADIL)}
                  </div>
                  <div>
                    <div className='wallet-title'>
                      <img src={ICON_META_HORSE} alt='' className='wallet-icon' width={20} />
                      {t(`${NOTIFICATION_MESSAGE}.gameCoin`)}
                    </div>
                    {layoutCoin(GAME_TOKEN_KUDA, CURRENCY_TYPE.KUDA, coinKuda ?? '0')}
                    {layoutCoin(GAME_TOKEN_MERAH, CURRENCY_TYPE.MERAH, coinMerah ?? '0')}
                  </div>
                </div>
              </div>
            </div>
            <div className='container'>
              <div className='balance-container'>
                <div className='balance'>
                  <div className='title font-bold'>{t(`${NOTIFICATION_MESSAGE}.donate`)}</div>
                  <img src={TWO_LINE} alt='' className='line' />
                </div>
                <div className='donate'>
                  <div className='donate-user'>
                    <div className='field-value'>
                      <InputPrizePool
                        type='text'
                        value={inputUser?.toString()}
                        onChange={handleChangeCoinInput}
                        onKeyDown={_handleKeyDownPrize}
                        heigth={40}
                        width={600}
                      />
                      <div className='select-currency'>
                        <SelectCustomCreateRace
                          dataSelect={currencyOptions}
                          nameSelect={currencySelected}
                          onSelected={(val: any) => {
                            setCurrencySelected(val.name)
                            setInputUser(0)
                          }}
                          isShowIcon
                        />
                      </div>
                    </div>
                  </div>
                  <div className={`${isShowWarning ? 'text-center text-error' : 'visibility-hidden'}`}>
                        Not enough gas for transaction
                      </div>
                  <div className='action'>
                    <Button
                      type='btnCancel'
                      buttonName={t(`${GUILD_MESSAGE}.cancel`)}
                      onClickButton={onCloseButtonClick}
                      width={147}
                    />
                    <Button
                      isLoading={loadingSubmit}
                      buttonName={t(`${GUILD_MESSAGE}.donate`)}
                      onClickButton={handleSave}
                      width={147}
                      disabled={!Number(inputUser)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {openInProgressBalanceModal && <InProgressBalanceModal title={'DONATE IN PROGRESS'} />}
        {isConfirm && (
          <ModalConfirm
            onClose={() => setIsConfirm(false)}
            onConfirm={handleConfirmSubmit}
            titleModal='Confirm Donation'
            loading={loadingSubmit}
            content={
             <>
              <div className='content-confirm'>
                <div>You’re donating {`${inputUser?.toString()}`}</div>
                <div>
                  {currencyOptions.find((it) => it.name === currencySelected)?.icon}
                </div>
                <div>{currencySelected}</div>
              </div>
              <div>
                This can’t be undone.
              </div>
             </>
            }
            margingTop={true}
            widthM={550}
            heightM={250}
          />
        )}
      </ModalDonateCoinStyled>
    </Modal>
  )
}
